import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

var firebase = require('firebase/app');

const firebaseConfig = {
  apiKey: 'AIzaSyBraqgKxrrqLBkk6Jf4Y8b_H-47AoJjCKY',
  authDomain: 'softie-pals.firebaseapp.com',
  databaseURL: 'https://softie-pals.firebaseio.com',
  projectId: 'softie-pals',
  storageBucket: 'softie-pals.appspot.com',
  messagingSenderId: '2015829189',
  appId: '1:2015829189:web:178dfbed2c1c0c7453e4ac',
  measurementId: 'G-WL8J92DEXV',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
